// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__rzMUs","rootSmall":"AddTileButton_rootSmall__1Mpzm"};